import React from 'react';
import PropTypes from 'prop-types';

const Tile = ({
	children,
}) => (
	<div className="tile">
		{children}
	</div>
);

export default Tile;

Tile.propTypes = {
	children: PropTypes.node.isRequired,
};
